class ContentTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('[role="tab"]');
    this.tablist = this.querySelector('[role="tablist"]');
    this.tabFocus = 0;

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onTabClick = this.onTabClick.bind(this);

    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabClick);
    });

    this.tablist.addEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(evt) {
    // right
    if (evt.keyCode === 39 || evt.keyCode === 37) {
      this.tabs[this.tabFocus].setAttribute('tabindex', -1);
      if (evt.keyCode ===   39) {
        this.tabFocus++;
        if (this.tabFocus >= this.tabs.length) {
          this.tabFocus = 0;
        }
      } else if (evt.keyCode === 37) {
        this.tabFocus--;
        if (this.tabFocus < 0) {
          this.tabFocus = this.tabs.length -1;
        }
      }
      this.tabs[this.tabFocus].setAttribute('tabindex', 0);
      this.tabs[this.tabFocus].focus();
    }
  }

  onTabClick(evt) {
    const target = evt.target;
    const parent = target.parentNode;
    parent.querySelectorAll('[aria-selected="true"]').forEach(item => item.setAttribute('aria-selected', false));
    target.setAttribute('aria-selected', true);
    this.querySelectorAll('[role="tabpanel"]').forEach(item => item.setAttribute('hidden', true));
    this.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
  }
}

customElements.define('content-tabs', ContentTabs);